import React from 'react';

const InboxFilters = ({ 
  selectedAccount, 
  onAccountChange, 
  emailAccounts, 
  formatEmailAddress,
  showMoreFilters,
  selectedTag,
  onTagChange,
  aiTags,
  emails,
  enthusiasmFilter,
  onEnthusiasmFilterChange
}) => {
  return (
    <>
      {/* Konto-Auswahl-Leiste - nur anzeigen wenn More Filters aktiv */}
      {showMoreFilters && (
        <div className="smartInbox_accounts_bar">
          <button 
            className={`smartInbox_account_button ${selectedAccount === 'all' ? 'active' : ''}`}
            onClick={() => onAccountChange('all')}
          >
            All Inboxes
          </button>
          
          {/* Option für gesendete E-Mails */}
          <button 
            className={`smartInbox_account_button ${selectedAccount === 'sent' ? 'active' : ''}`}
            onClick={() => onAccountChange('sent')}
          >
            Sent
          </button>

          {/* Neue Option für Replied Emails - Unterfilter von Sent Emails */}
          <button 
            className={`smartInbox_account_button ${selectedAccount === 'replied' ? 'active' : ''}`}
            onClick={() => onAccountChange('replied')}
          >
            Replied
          </button>

          {/* Option für weitergeleitete E-Mails */}
          <button 
            className={`smartInbox_account_button ${selectedAccount === 'forwarded' ? 'active' : ''}`}
            onClick={() => onAccountChange('forwarded')}
          >
            Forwarded
          </button>
          
          {/* Option für gelöschte E-Mails */}
    
          
          {/* Option für geplante E-Mails */}
          <button 
            className={`smartInbox_account_button ${selectedAccount === 'scheduled' ? 'active' : ''}`}
            onClick={() => onAccountChange('scheduled')}
          >
            Scheduled
          </button>
          <button 
            className={`smartInbox_account_button ${selectedAccount === 'deleted' ? 'active' : ''}`}
            onClick={() => onAccountChange('deleted')}
          >
            Deleted
          </button>
          {emailAccounts.map((account) => (
            <button 
              key={account.id}
              className={`smartInbox_account_button ${selectedAccount === account.id ? 'active' : ''}`}
              onClick={() => onAccountChange(account.id)}
              title={account.email}
            >
              {formatEmailAddress(account.email)}
            </button>
          ))}
        </div>
      )}

      {/* AI Tag-Filter-Leiste - nur anzeigen wenn More Filters aktiv */}
      {showMoreFilters && selectedAccount !== 'sent' && selectedAccount !== 'replied' && selectedAccount !== 'forwarded' && selectedAccount !== 'scheduled' && selectedAccount !== 'deleted' && emails.length > 0 && aiTags.length > 0 && (
        <div className="smartInbox_filter_bar smartInbox_tag_filter_bar" style={{ marginBottom: '10px', marginTop: '-5px' }}>
          <span className="smartInbox_filter_label">Filter by AI Tag:</span>
          <button 
            className={`smartInbox_filter_button ${selectedTag === 'all' ? 'active' : ''}`}
            onClick={() => onTagChange('all')}
          >
            All Tags
          </button>
          {aiTags.map((tag) => {
            // Zähle E-Mails mit diesem Tag
            const emailsWithTag = emails.filter(email => 
              email.tags && Object.values(email.tags).some(t => t.tag === tag.tag)
            ).length;
            
            return (
              <button 
                key={tag.id}
                className={`smartInbox_filter_button ${selectedTag === tag.tag ? 'active' : ''}`}
                onClick={() => onTagChange(tag.tag)}
                style={{
                  backgroundColor: selectedTag === tag.tag ? tag.color : 'transparent',
                  color: selectedTag === tag.tag ? '#fff' : tag.color,
                  border: `1px solid ${tag.color}`
                }}
                title={`${tag.name} (${emailsWithTag} emails)`}
              >
                {tag.name} ({emailsWithTag})
              </button>
            );
          })}
        </div>
      )}

      {/* Enthusiasmus-Filter-Leiste - nur anzeigen wenn More Filters aktiv */}
      {showMoreFilters && selectedAccount !== 'sent' && selectedAccount !== 'replied' && selectedAccount !== 'forwarded' && selectedAccount !== 'scheduled' && selectedAccount !== 'deleted' && emails.length > 0 && (
        <div className="smartInbox_filter_bar">
          <span className="smartInbox_filter_label">Enthusiasm Level:</span>
          <button 
            className={`smartInbox_filter_button ${enthusiasmFilter === 'all' ? 'active' : ''}`}
            onClick={() => onEnthusiasmFilterChange('all')}
          >
            All Emails
          </button>
          <button 
            className={`smartInbox_filter_button enthusiasm_high ${enthusiasmFilter === 'enthusiastic' ? 'active' : ''}`}
            onClick={() => onEnthusiasmFilterChange('enthusiastic')}
          >
            Enthusiastic (≥5)
          </button>
        </div>
      )}
    </>
  );
};

export default InboxFilters; 